import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {IShippingWithCluster} from "features/plan/types";

type TGroupedTooltip = Record<string, Record<string, {
  count: number;
  scannedCount: number;
}>>;

const EMPTY_STATUS = "undefined";

export const PlansTooltip = ({
                               shippings,
                             }: {
  shippings?: IShippingWithCluster[];
}) => {
  const {t} = useTranslation("shipping");
  
  const groupedShippings = useMemo(() => {
    if (shippings && shippings.length > 4) {
      const nextGrouped: TGroupedTooltip = {};
      
      shippings.forEach((shipping) => {
        const clusterId = shipping.cluster_id;
        const status = shipping.shipping_item__status || EMPTY_STATUS;
        
        if (!nextGrouped[clusterId]) {
          nextGrouped[clusterId] = {};
        }
        
        if (!nextGrouped[clusterId][status]) {
          nextGrouped[clusterId][status] = {
            count: 0, scannedCount: 0,
          };
        }
        
        nextGrouped[clusterId][status].count += 1;
        
        if (shipping.is_scanned) {
          nextGrouped[clusterId][status].scannedCount += 1;
        }
      });
      
      return nextGrouped;
    }
    
    return;
  }, [shippings]);
  
  const getDotClassName = (scannedCount: number) => {
    if (scannedCount > 0) {
      return "true";
    }
    
    return "false";
  };
  
  const formatStatusLabel = (status?: string) => {
    if (!status || status === EMPTY_STATUS) {
      return "-";
    }
    
    return t(status);
  };
  
  if (groupedShippings) {
    return (<div className={"content"}>
      {Object.keys(groupedShippings)
             .map((clusterId) => {
               const statusObj = groupedShippings[clusterId];
               const statusList = Object.keys(statusObj);
               
               return (<div key={"plantoolSector" + clusterId} className={"sector-row"}>
                 <span>{clusterId}</span>
                 <div className={"column"}>
                   {statusList.map((status) => (<div key={`plantoolStatus${clusterId}${status}`} className={"row"}>
                     <span>{formatStatusLabel(status)}</span>
                     <div className={"right"}>
                       <div
                         className={`dot ${getDotClassName(statusObj[status].scannedCount)}`}
                       />
                       {statusObj[status].count}
                     </div>
                   </div>))}
                 </div>
               </div>)
             })}
    </div>);
  }
  
  if (shippings && shippings.length) {
    return (<div className={"content"}>
      {shippings.map((s) => (
        <div key={`shippinginfo${s.cluster_id}${s.shipping_item__tracking_number}`} className={"row"}>
          <span className={"bold"}>{s.cluster_id}</span>
          <div className={"right"}>
            <div
              className={"dot " + s.is_scanned}
            />
            {formatStatusLabel(s.shipping_item__status)}
          </div>
        </div>))}
    </div>);
  }
  
  return null;
};
